import React from "react";

// components

import CardStats from "components/Cards/CardStats.js";
import CardButton from "components/Cards/CardButton";

export default function HeaderStats({ page, create }) {
  // console.log(create);
  return (
    <>
      {/* Header */}
      <div className="relative pt-12 pb-20 bg-no-repeat md:pt-32 bg-blueGray-800 bg-full" style={{
        backgroundImage:
          "url(" + require("assets/img/register_bg_2.png") + ")",
      }}>
        <div className="w-full px-4 mx-auto md:px-10">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap ">
              <div className="w-full px-4 lg:w-6/12 xl:w-3/12 ">
                <CardStats
                  statSubtitle="TRAFFIC"
                  statTitle={page}

                />
              </div>
              <div className="w-full px-4 lg:w-6/12 xl:w-3/12">
              </div>
              <div className="w-full px-4 lg:w-6/12 xl:w-3/12">
              </div>
              <div className="flex justify-end w-full px-4 lg:w-6/12 xl:w-3/12">

                {create && <CardButton
                  create={create}
                ></CardButton>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
